import { sendGtmEvent } from '@zurich-framework/nextapp/client';
import { isServerSide } from '@zurich-framework/nextapp/common';
import { useEffect } from 'react';

export interface UseGtmProps {
  formStep: string | undefined;
}

export function useGtm({ formStep }: UseGtmProps): void {
  useEffect(() => {
    if (!isServerSide() && formStep) {
      sendGtmEvent({ event: 'step', form_step: formStep });
    }
  }, [formStep]);
}
